import { render, staticRenderFns } from "./CompManage.vue?vue&type=template&id=b909adf4&scoped=true&"
import script from "./CompManage.vue?vue&type=script&lang=js&"
export * from "./CompManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b909adf4",
  null
  
)

export default component.exports